import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { isPlatformServer } from '@angular/common';

import { Store } from '@ngrx/store';

import { CartStatus } from '@fcom/dapi/interfaces';
import { snapshot } from '@fcom/rx';
import { BookingAppState } from '@fcom/common/interfaces/booking';

import { cartStatusSelector, cartUrl } from '../store/selectors';
import { BookingCartService } from './booking-cart.service';

@Injectable()
export class BookingGuard implements CanActivate {
  private cartService = inject(BookingCartService);
  private store$ = inject<Store<BookingAppState>>(Store);
  private platform = inject(PLATFORM_ID);
  private readonly cartStatus = this.store$.selectSignal(cartStatusSelector);

  private initialRoute = true;

  canActivate(_route: ActivatedRouteSnapshot): boolean {
    if (isPlatformServer(this.platform)) {
      return true;
    }

    if (this.initialRoute) {
      const currentCartStatus = this.cartStatus();
      const cUrl = snapshot(this.store$.pipe(cartUrl()));
      if ([CartStatus.INITIAL, CartStatus.OK].indexOf(currentCartStatus) === -1 && !!cUrl) {
        this.cartService.triggerLoadCart(cUrl); // This is called rarely from mobile app.
      }
    }

    this.initialRoute = false;
    return true;
  }
}
